import { Component } from '@angular/core';

@Component({
    selector: 'app-non-signing-agent-welcome',
    templateUrl: './non-signing-agent-welcome.component.html',
    styleUrls: ['./non-signing-agent-welcome.component.scss'],
    standalone: false
})
export class NonSigningAgentWelcomeComponent {}
